var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#464D6D",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3H4C3.73478 3 3.48043 3.10536 3.29289 3.29289C3.10536 3.48043 3 3.73478 3 4V6.59C3 7.113 3.213 7.627 3.583 7.997L9 13.414V21C9.0002 21.1704 9.04387 21.3379 9.1269 21.4867C9.20992 21.6354 9.32955 21.7605 9.47444 21.8502C9.61934 21.9398 9.78471 21.9909 9.9549 21.9988C10.1251 22.0066 10.2945 21.9709 10.447 21.895L14.447 19.895C14.786 19.725 15 19.379 15 19V13.414L20.417 7.997C20.787 7.627 21 7.113 21 6.59V4C21 3.73478 20.8946 3.48043 20.7071 3.29289C20.5196 3.10536 20.2652 3 20 3ZM13.293 12.293C13.2 12.3857 13.1262 12.4959 13.0759 12.6172C13.0256 12.7386 12.9998 12.8687 13 13V18.382L11 19.382V13C11.0002 12.8687 10.9744 12.7386 10.9241 12.6172C10.8738 12.4959 10.8 12.3857 10.707 12.293L5 6.59V5H19.001L19.003 6.583L13.293 12.293Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.be1627f9.svg";
export { ForwardRef as ReactComponent };